import React, { useContext, useState } from "react";
import { userType } from "../utils/auth";

const AuthContext = React.createContext(null);

const AuthProvider = ({ children, ...rest }) => {
  const [user, setUser] = useState({ roles: [userType()] });
  return (
    <AuthContext.Provider value={{ user, setUser }} {...rest}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
